import { defineStore } from 'pinia';
import { getUnreadAnnouncementCountRequest } from '../services/apiServices';

const COUNT_CACHE_TTL_MS = 15000;
let unreadCountRequest = null;
let unreadCountGeneration = 0;

const normalizeUnreadCount = (value) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const useAnnouncements = defineStore('announcements', {
    state: () => ({
        unreadCount: 0,
        isLoadingUnreadCount: false,
        unreadCountLoadedAt: 0
    }),
    actions: {
        setUnreadCount(value) {
            this.unreadCount = normalizeUnreadCount(value);
            this.unreadCountLoadedAt = Date.now();
        },
        resetUnreadCount() {
            unreadCountGeneration += 1;
            this.unreadCount = 0;
            this.isLoadingUnreadCount = false;
            this.unreadCountLoadedAt = 0;
            unreadCountRequest = null;
        },
        async loadUnreadCount({ force = false } = {}) {
            const isFresh = (
                this.unreadCountLoadedAt > 0
                && Date.now() - this.unreadCountLoadedAt < COUNT_CACHE_TTL_MS
            );
            if (!force && isFresh) {
                return this.unreadCount;
            }
            if (unreadCountRequest) {
                return unreadCountRequest;
            }

            this.isLoadingUnreadCount = true;
            const requestGeneration = unreadCountGeneration;
            const request = getUnreadAnnouncementCountRequest()
                .then((data) => {
                    if (requestGeneration === unreadCountGeneration) {
                        this.setUnreadCount(data?.unreadCount);
                    }
                    return this.unreadCount;
                })
                .finally(() => {
                    if (unreadCountRequest === request) {
                        this.isLoadingUnreadCount = false;
                        unreadCountRequest = null;
                    }
                });
            unreadCountRequest = request;

            return unreadCountRequest;
        }
    }
});
